/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：813
 */

module.exports = {
  floatPanel: "float_floatPanel__3G0yX",
  floatIcon: "float_floatIcon__nD8Tn",
  close: "float_close__iHQXD"
}
